(() => {
  "use strict";
  document.querySelectorAll(".cq-credit,.qa-credit").forEach((e) => e.remove());
  const awardLinks = document.querySelectorAll("[data-award-view]");
  if (awardLinks.length) {
    const viewer = document.createElement("dialog");
    viewer.className = "cq-award-viewer";
    viewer.setAttribute("aria-label", "Award artwork");
    const close = document.createElement("button");
    close.className = "cq-product-close";
    close.type = "button";
    close.textContent = "×";
    close.setAttribute("aria-label", "Close award artwork");
    const picture = document.createElement("img");
    viewer.append(close, picture);
    document.body.append(viewer);
    let active;
    close.addEventListener("click", () => viewer.close());
    viewer.addEventListener("click", e => { if (e.target === viewer) viewer.close(); });
    viewer.addEventListener("close", () => active?.focus());
    awardLinks.forEach(a => a.addEventListener("click", e => {
      e.preventDefault(); active = a;
      picture.src = a.href;
      picture.alt = a.closest("figure")?.querySelector("h3")?.textContent || "CAQA award";
      viewer.showModal();
    }));
  }
  // Do not allow old scroll scripts to turn the service selector into an overlay.
  document.querySelectorAll(".finder-wrap").forEach((e) => {
    e.removeAttribute("data-finder-bar");
    e.style.setProperty("position", "static", "important");
    e.style.setProperty("transform", "none", "important");
  });
  const filter = document.querySelector("[data-pd-filter]");
  if (filter) {
    const search = filter.elements["pd-search"],
      category = filter.elements["pd-category"],
      cards = [...document.querySelectorAll("[data-pd-search]")];
    const run = (e) => {
      e?.preventDefault();
      const q = search.value.trim().toLowerCase();
      let count = 0;
      for (const c of cards) {
        c.hidden = !(
          c.dataset.pdSearch.toLowerCase().includes(q) &&
          (!category.value || c.dataset.pdCategory === category.value)
        );
        if (!c.hidden) count++;
      }
      document.querySelector("[data-pd-count]").textContent =
        count + " recording" + (count === 1 ? "" : "s");
      document.querySelector("[data-pd-empty]").hidden = count !== 0;
    };
    filter.addEventListener("submit", run);
    search.addEventListener("input", run);
    category.addEventListener("change", run);
  }
})();
